export default {
  methods : {
    getDateFromString(string){
      string = string.trim();
      let dateTime = string.split(' ');
      let date = dateTime[0].trim().split('-');
      let time = dateTime[1].trim().split(':');
      date[1] -= 1;
      dateTime = date.concat(time);
      return new Date(...dateTime)

    },
    isCurrentDate(from, to) {
      let now = new Date();
      return this.getDateFromString(from) <= now &&  now <= this.getDateFromString(to)
    }
  },
}
